/* CompleteGuideSection — the entire BeX App abstraction reference, rendered
 * AS-IS from a static asset (public/complete-guide.html, a byte-for-byte copy
 * of strategies/S-0005/coverage/abstraction.html). It's a whole self-contained
 * page: its own inline style, an embedded data block, and inline scripts for
 * its filters / mobile nav / scroll-spy. We ship it as a CRA public asset and
 * mount it in an iframe (src) so it keeps its own design and its interactivity
 * runs in isolation. This app is CRA/craco/webpack, which has no Vite raw
 * import — a public asset + iframe src is the correct embed. The iframe fills
 * the guide body below the ~57px sticky tab bar and scrolls internally. */

const GUIDE_URL = (process.env.PUBLIC_URL || "") + "/complete-guide.html";

export function CompleteGuideSection() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: "calc(100vh - 58px)",
      }}
    >
      <iframe
        title="Complete Guide"
        src={GUIDE_URL}
        style={{
          flex: 1,
          width: "100%",
          minHeight: "calc(100vh - 58px)",
          border: 0,
          display: "block",
        }}
      />
    </div>
  );
}
